import { MessageCircle, Phone, MapPin } from "lucide-react";
import { waLink, telLink } from "@/lib/api";

export default function StickyBar({ settings }) {
  return (
    <div
      data-testid="sticky-action-bar"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-border bg-white/90 backdrop-blur-xl md:hidden"
    >
      <a
        data-testid="sticky-whatsapp"
        href={waLink(settings, "Hola Electrodomésticos Rivera, quiero cotizar un electrodoméstico.")}
        target="_blank"
        rel="noopener noreferrer"
        className="flex min-h-[60px] flex-col items-center justify-center gap-1 bg-whatsapp text-xs font-semibold text-white"
      >
        <MessageCircle className="h-5 w-5" /> WhatsApp
      </a>
      <a
        data-testid="sticky-call"
        href={telLink(settings)}
        className="flex min-h-[60px] flex-col items-center justify-center gap-1 text-xs font-semibold text-primary"
      >
        <Phone className="h-5 w-5" /> Llamar
      </a>
      <a
        data-testid="sticky-location"
        href="#ubicaciones"
        className="flex min-h-[60px] flex-col items-center justify-center gap-1 text-xs font-semibold text-primary"
      >
        <MapPin className="h-5 w-5" /> Ubicación
      </a>
    </div>
  );
}
